import { render } from "./RenameAndCategorize.vue?vue&type=template&id=7b97ae82&scoped=true"
import script from "./RenameAndCategorize.vue?vue&type=script&lang=js"
export * from "./RenameAndCategorize.vue?vue&type=script&lang=js"

import "../../assets/scss/document_edit.scss?vue&type=style&index=0&id=7b97ae82&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b97ae82"]])

export default __exports__